<template>
  <div class="pa-7" id="environment">
    <!--タイトル-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--内容-->
    <v-row>
      <v-col cols="12">
      <p>
        ・Linux、Windows等Java 8が動作する環境で動作可能です。
      </p>
      <p>
        ・検索エンジンはApache Lucene(http://activemq.apache.org)を利用しています。
      </p>
      <p>
        ・データベースはデフォルトはPostgreSQLで他のデータベースに対応できます。
      </p>
      </v-col>
    </v-row>
  </div>
</template>

<style>
.subHead {
  font-size: 25px;
}

.summary {
  vertical-align: middle;
  font-size: 16px;
}
v-list-item{
  margin-bottom:-8px;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '動作環境',
      // タイトル横のアイコン
      icon: 'mdi-desktop-mac-dashboard',
      // 説明文
      description: 'Linux、Windows等Java 8が動作する可能で動作可能です。',
      description1: '検索エンジンはApache Lucene(http://activemq.apache.org)を利用しています。データベースはデフォルトはPostgreSQLで他のデータベースに対応できます。導入事例国立大学医学部E-Learningシステムのコンテンツ全文検索企業向け技術資料全文検索システム国立大学医学部同窓会会報全文検索システム'
    }
  }
}
</script>
